import React from "react";

// Public Imports
// const ForgetPassword = React.lazy(() => import("../containers/AuthPages/ForgetPassword"));
// const ResetPassword = React.lazy(() => import("../containers/AuthPages/ResetPassword"));
// const SetPassword = React.lazy(() => import("../containers/AuthPages/SetPassword/SetPassword"));
const LandingPage = React.lazy(() => import("../Containers/LandingPage/index"));
const AdminLogin = React.lazy(() =>
  import("../Containers/AdminPanel/AdminLogin/AdminLogin")
);
const Categories = React.lazy(() =>
  import("../Containers/CustomerPanel/Categories/Categories")
);
const CarPooling = React.lazy(() =>
  import("../Containers/CarPooling/CarPooling")
);

const EditCustomerProfile = React.lazy(() =>
  import("../Containers/CustomerPanel/EditCustomerProfile/EditCustomerProfile")
);
const PoolRider = React.lazy(() =>
  import("../Containers/CarPooling/PoolRider/PoolRider")
);
const MyPoolings = React.lazy(() =>
  import("../Containers/CarPooling/PoolRider/MyPoolings/MyPoolings")
);
const PoolRiderRegistration = React.lazy(() =>
  import(
    "../Containers/CarPooling/PoolRider/PoolRiderRegistration/PoolRiderRegistration"
  )
);
const PoolSearch = React.lazy(() =>
  import("../Containers/CarPooling/PoolSearch/PoolSearch")
);
const CategoriesWithMap = React.lazy(() =>
  import("../Containers/CustomerPanel/CategoriesWithMap/CategoriesWithMap")
);
const SpecificShopCars = React.lazy(() =>
  import("../Containers/CustomerPanel/SpecificShopCars/SpecificShopCars")
);
const Brands = React.lazy(() => import("../Containers/CustomerPanel/Brands"));
const CustomerSignIn = React.lazy(() =>
  import("../Containers/CustomerPanel/CustomerAuthentication/Signin")
);
const CustomerSignUp = React.lazy(() =>
  import("../Containers/CustomerPanel/CustomerAuthentication/Signup")
);
const ShopKeeperSignUp = React.lazy(() =>
  import("../Containers/ShopKeeperPanel/ShopKeeperAuthentication/Signup")
);

// const Login = React.lazy(() => import("../containers/AuthPages/Login"));

// Protected Imports
const AdminProfile = React.lazy(() =>
  import("../Containers/AdminPanel/AdminProfile/AdminProfile")
);
const AdminDashboard = React.lazy(() =>
  import("../Containers/AdminPanel/AdminDashboard/AdminDashboard")
);
const AdminListing = React.lazy(() =>
  import("../Containers/AdminPanel/AdminListing/AdminListing")
);
const AdminRequests = React.lazy(() =>
  import("../Containers/AdminPanel/AdminRequests/AdminRequests")
);

// ShopKeeper
const CarListing = React.lazy(() =>
  import("../Containers/ShopKeeperPanel/CarListing/CarListing")
);
const AddNewCar = React.lazy(() =>
  import("../Containers/ShopKeeperPanel/AddCar/AddCar")
);
const EditShopDetails = React.lazy(() =>
  import("../Containers/ShopKeeperPanel/EditShopDetails/EditShopDetails")
);
const ShopKeeperBookings = React.lazy(() =>
  import("../Containers/ShopKeeperPanel/ShopKeeperBookings/ShopKeeperBookings")
);

const PoolingRequest = React.lazy(() => import("../Containers/PoolingRequest"));

const EditCar = React.lazy(() =>
  import("../Containers/ShopKeeperPanel/EditCar/EditCar")
);

// User
const CustomerBookings = React.lazy(() =>
  import("../Containers/CustomerPanel/CustomerBookings/CustomerBookings")
);

const MyBooking = React.lazy(() =>
  import("../Containers/CustomerPanel/MyBookings/MyBooking")
);

export const UNAUTHENTICATED_ROUTES = {
  LANDING_PAGE: "/",
  CUSTOMER_SIGNIN: "/customer-signin",
  CUSTOMER_SIGNUP: "/customer-signup",
  SHOPKEEPER_SIGNUP: "/shopkeeper-signup",
  ADMIN_LOGIN: "/admin-login",
  CATEGORIES: "/categories",
  CAR_POOLING: "/car-pooling",
  POOL_RIDER: "/rider-pooling",
  POOL_SEARCH: "/pool-search",
  CATEGORIES_WITH_MAP: "/categories-map",
  SPECIFIC_SHOP_CARS: "/categories/:id",
  BRANDS: "/brands",
  EDIT_CUSTOMER_PROFILE: "/edit-customer-profile",
  // RESET_PASSWORD: "/reset-password/:resetToken",
  // FORGET_PASSWORD: "/forget-password",
  // SET_PASSWORD: "/set-password/:userId",
  // EVENT_SUCCESS: "/event-submitted"
};

export const AUTHENTICATED_ROUTES = {
  // Admin
  ADMIN_DASHBOARD: "/admin-dashboard",
  ADMIN_PROFILE: "/admin-profile",
  ADMIN_REQUESTS: "/admin-requests",
  ADMIN_LISTING: "/admin-adminListing",
  EDIT_LISTING: "/list/:id",

  // ShopKeeper
  CAR_LISTING: "/car-listing",
  ADD_NEW_CAR: "/add-new-car",
  EDIT_CAR: "/edit-car/:id",
  EDIT_SHOP_DETAILS: "/edit-shop-details",
  SHOPKEEPER_BOOKINGS: "/shopkeeper-bookings",

  // User
  CUSTOMER_BOOKINGS: "/customer-bookings/:id",
  MY_BOOKINGS: "/my-bookings",

  // POOLING
  POOL_RIDER_REGISTRATION: "/rider-registration",
  MY_POOLINGS: "/my-poolings",
  POOLING_REQUEST: "/pooling-request",
};

export const routes = [
  // Unauthentic Routes
  {
    name: "Landing Page",
    link: UNAUTHENTICATED_ROUTES.LANDING_PAGE,
    component: LandingPage,
  },
  {
    name: "Customer Sigin",
    link: UNAUTHENTICATED_ROUTES.CUSTOMER_SIGNIN,
    component: CustomerSignIn,
  },
  {
    name: "Customer Signup",
    link: UNAUTHENTICATED_ROUTES.CUSTOMER_SIGNUP,
    component: CustomerSignUp,
  },
  {
    name: "Shopkeeper Sigup",
    link: UNAUTHENTICATED_ROUTES.SHOPKEEPER_SIGNUP,
    component: ShopKeeperSignUp,
  },
  {
    name: "Admin Login",
    link: UNAUTHENTICATED_ROUTES.ADMIN_LOGIN,
    component: AdminLogin,
  },
  {
    name: "Cars",
    link: UNAUTHENTICATED_ROUTES.CATEGORIES,
    component: Categories,
  },
  {
    name: "Categories With Map",
    link: UNAUTHENTICATED_ROUTES.CATEGORIES_WITH_MAP,
    component: CategoriesWithMap,
  },
  {
    name: "Specific Shop Cars",
    link: UNAUTHENTICATED_ROUTES.SPECIFIC_SHOP_CARS,
    component: SpecificShopCars,
  },
  {
    name: "Car Pooling",
    link: UNAUTHENTICATED_ROUTES.CAR_POOLING,
    component: CarPooling,
  },
  {
    name: "Edit Customer Profile",
    link: UNAUTHENTICATED_ROUTES.EDIT_CUSTOMER_PROFILE,
    component: EditCustomerProfile,
  },
  {
    name: "Rider Pooling",
    link: UNAUTHENTICATED_ROUTES.POOL_RIDER,
    component: PoolRider,
  },
  {
    name: "Search Car Pooling",
    link: UNAUTHENTICATED_ROUTES.POOL_SEARCH,
    component: PoolSearch,
  },
  {
    name: "Rider Registration",
    link: AUTHENTICATED_ROUTES.POOL_RIDER_REGISTRATION,
    component: PoolRiderRegistration,
    access: ["user"],
  },
  {
    name: "My Poolings",
    link: AUTHENTICATED_ROUTES.MY_POOLINGS,
    component: MyPoolings,
    access: ["user"],
  },
  {
    name: "Brands",
    link: UNAUTHENTICATED_ROUTES.BRANDS,
    component: Brands,
  },
  //   Authenticated Routes
  {
    name: "Car Listing",
    link: AUTHENTICATED_ROUTES.CAR_LISTING,
    access: ["shopkeeper"],
    component: CarListing,
  },
  {
    name: "Add New Car",
    link: AUTHENTICATED_ROUTES.ADD_NEW_CAR,
    access: ["shopkeeper"],
    component: AddNewCar,
  },
  {
    name: "Edit Car Details",
    link: AUTHENTICATED_ROUTES.EDIT_CAR,
    access: ["shopkeeper"],
    component: EditCar,
  },
  {
    name: "Edit Shop Details",
    link: AUTHENTICATED_ROUTES.EDIT_SHOP_DETAILS,
    access: ["shopkeeper"],
    component: EditShopDetails,
  },
  {
    name: "Shopkeeper Bookings",
    link: AUTHENTICATED_ROUTES.SHOPKEEPER_BOOKINGS,
    access: ["shopkeeper"],
    component: ShopKeeperBookings,
  },
  //   User
  {
    name: "Customer Bookings",
    link: AUTHENTICATED_ROUTES.CUSTOMER_BOOKINGS,
    access: ["user"],
    component: CustomerBookings,
  },
  {
    name: "My Bookings",
    link: AUTHENTICATED_ROUTES.MY_BOOKINGS,
    access: ["user"],
    component: MyBooking,
  },
  {
    name: "Pooling Request",
    link: AUTHENTICATED_ROUTES.POOLING_REQUEST,
    access: ["user"],
    component: PoolingRequest,
  },
  //   Admin
  {
    name: "Admin Dashboard",
    link: AUTHENTICATED_ROUTES.ADMIN_DASHBOARD,
    access: ["admin"],
    component: AdminDashboard,
  },
  {
    name: "Admin Profile",
    link: AUTHENTICATED_ROUTES.ADMIN_PROFILE,
    access: ["admin"],
    component: AdminProfile,
  },
  {
    name: "Admin Listing",
    link: AUTHENTICATED_ROUTES.ADMIN_LISTING,
    access: ["admin"],
    component: AdminListing,
  },
  {
    name: "Admin Requests",
    link: AUTHENTICATED_ROUTES.ADMIN_REQUESTS,
    access: ["admin"],
    component: AdminRequests,
  },
];
